import { WorldCountry } from '../types';

export const unitedKingdomExpanded2: WorldCountry = {
  code: 'GB',
  name: 'United Kingdom',
  slug: 'united-kingdom',
  population: 67500000,
  topCities: [
    // Major cities (keeping existing ones)
    { name: 'London', slug: 'london', population: 9648110 },
    { name: 'Birmingham', slug: 'birmingham', population: 1149000 },
    { name: 'Manchester', slug: 'manchester', population: 547000 },
    { name: 'Glasgow', slug: 'glasgow', population: 635130 },
    { name: 'Liverpool', slug: 'liverpool', population: 498042 },
    { name: 'Leeds', slug: 'leeds', population: 789194 },
    { name: 'Sheffield', slug: 'sheffield', population: 584853 },
    { name: 'Edinburgh', slug: 'edinburgh', population: 518500 },
    { name: 'Bristol', slug: 'bristol', population: 467099 },
    { name: 'Cardiff', slug: 'cardiff', population: 364248 },
    
    // Extended cities to reach 100
    { name: 'Leicester', slug: 'leicester', population: 355218 },
    { name: 'Coventry', slug: 'coventry', population: 371521 },
    { name: 'Bradford', slug: 'bradford', population: 537173 },
    { name: 'Belfast', slug: 'belfast', population: 343542 },
    { name: 'Newcastle', slug: 'newcastle', population: 300196 },
    { name: 'Nottingham', slug: 'nottingham', population: 332900 },
    { name: 'Plymouth', slug: 'plymouth', population: 264695 },
    { name: 'Stoke-on-Trent', slug: 'stoke-on-trent', population: 258366 },
    { name: 'Wolverhampton', slug: 'wolverhampton', population: 263700 },
    { name: 'Derby', slug: 'derby', population: 257302 },
    { name: 'Swansea', slug: 'swansea', population: 246466 },
    { name: 'Southampton', slug: 'southampton', population: 269781 },
    { name: 'Salford', slug: 'salford', population: 254408 },
    { name: 'Aberdeen', slug: 'aberdeen', population: 198590 },
    { name: 'Westminster', slug: 'westminster', population: 247614 },
    { name: 'Portsmouth', slug: 'portsmouth', population: 238137 },
    { name: 'York', slug: 'york', population: 210620 },
    { name: 'Peterborough', slug: 'peterborough', population: 202259 },
    { name: 'Dundee', slug: 'dundee', population: 148750 },
    { name: 'Lancaster', slug: 'lancaster', population: 52234 },
    { name: 'Oxford', slug: 'oxford', population: 154600 },
    { name: 'Cambridge', slug: 'cambridge', population: 145818 },
    { name: 'Gloucester', slug: 'gloucester', population: 136362 },
    { name: 'Exeter', slug: 'exeter', population: 130709 },
    { name: 'Scunthorpe', slug: 'scunthorpe', population: 82334 },
    { name: 'Gateshead', slug: 'gateshead', population: 120046 },
    { name: 'Middlesbrough', slug: 'middlesbrough', population: 138412 },
    { name: 'Blackpool', slug: 'blackpool', population: 139305 },
    { name: 'Bolton', slug: 'bolton', population: 194189 },
    { name: 'Bournemouth', slug: 'bournemouth', population: 183491 },
    { name: 'Norwich', slug: 'norwich', population: 140573 },
    { name: 'Swindon', slug: 'swindon', population: 185609 },
    { name: 'Crawley', slug: 'crawley', population: 118493 },
    { name: 'Ipswich', slug: 'ipswich', population: 144957 },
    { name: 'Wigan', slug: 'wigan', population: 107732 },
    { name: 'Croydon', slug: 'croydon', population: 192064 },
    { name: 'Walsall', slug: 'walsall', population: 288000 },
    { name: 'Mansfield', slug: 'mansfield', population: 110500 },
    { name: 'Oldham', slug: 'oldham', population: 237110 },
    { name: 'Warrington', slug: 'warrington', population: 210014 },
    { name: 'Stockport', slug: 'stockport', population: 295243 },
    { name: 'Rochdale', slug: 'rochdale', population: 220001 },
    { name: 'Rotherham', slug: 'rotherham', population: 265411 },
    { name: 'Luton', slug: 'luton', population: 225262 },
    { name: 'Huddersfield', slug: 'huddersfield', population: 177093 },
    { name: 'Preston', slug: 'preston', population: 147617 },
    { name: 'Northampton', slug: 'northampton', population: 249093 },
    { name: 'Milton Keynes', slug: 'milton-keynes', population: 287800 },
    { name: 'Maidstone', slug: 'maidstone', population: 173508 },
    { name: 'Reading', slug: 'reading', population: 174224 },
    { name: 'Watford', slug: 'watford', population: 102246 },
    { name: 'Slough', slug: 'slough', population: 163777 },
    { name: 'Southend-on-Sea', slug: 'southend-on-sea', population: 295310 },
    { name: 'Basildon', slug: 'basildon', population: 187659 },
    { name: 'Sunderland', slug: 'sunderland', population: 174286 },
    { name: 'Telford', slug: 'telford', population: 155570 },
    { name: 'Chelmsford', slug: 'chelmsford', population: 180194 },
    { name: 'Basingstoke', slug: 'basingstoke', population: 113776 },
    { name: 'Chesterfield', slug: 'chesterfield', population: 88483 },
    { name: 'Harlow', slug: 'harlow', population: 93374 },
    { name: 'Cheltenham', slug: 'cheltenham', population: 115800 },
    { name: 'Carlisle', slug: 'carlisle', population: 108414 },
    { name: 'Worcester', slug: 'worcester', population: 103872 },
    { name: 'Bath', slug: 'bath', population: 94782 },
    { name: 'Woking', slug: 'woking', population: 103932 },
    { name: 'Hastings', slug: 'hastings', population: 92661 },
    { name: 'Stevenage', slug: 'stevenage', population: 94470 },
    { name: 'Burton upon Trent', slug: 'burton-upon-trent', population: 72299 },
    { name: 'Eastbourne', slug: 'eastbourne', population: 109202 },
    { name: 'Redditch', slug: 'redditch', population: 85381 },
    { name: 'Lincoln', slug: 'lincoln', population: 103778 },
    { name: 'Colchester', slug: 'colchester', population: 121859 },
    { name: 'Preston', slug: 'preston-city', population: 114300 },
    { name: 'St Albans', slug: 'st-albans', population: 148641 },
    { name: 'Hemel Hempstead', slug: 'hemel-hempstead', population: 95985 },
    { name: 'Barnsley', slug: 'barnsley', population: 96888 },
    { name: 'Grimsby', slug: 'grimsby', population: 88243 },
    { name: 'Nuneaton', slug: 'nuneaton', population: 92698 },
    { name: 'Shrewsbury', slug: 'shrewsbury', population: 76782 },
    { name: 'Stockton-on-Tees', slug: 'stockton-on-tees', population: 198013 },
    { name: 'Hereford', slug: 'hereford', population: 60800 },
    { name: 'Darlington', slug: 'darlington', population: 107800 },
    { name: 'Hartlepool', slug: 'hartlepool', population: 93242 },
    { name: 'Macclesfield', slug: 'macclesfield', population: 63954 },
    { name: 'Aylesbury', slug: 'aylesbury', population: 74748 },
    { name: 'Crewe', slug: 'crewe', population: 76437 },
    { name: 'Wakefield', slug: 'wakefield', population: 109766 },
    { name: 'Blackburn', slug: 'blackburn', population: 117963 },
    { name: 'Burnley', slug: 'burnley', population: 149422 },
    { name: 'Tamworth', slug: 'tamworth', population: 81964 },
    { name: 'Stafford', slug: 'stafford', population: 71673 },
    { name: 'Canterbury', slug: 'canterbury', population: 61707 },
    { name: 'Scarborough', slug: 'scarborough', population: 61749 },
    { name: 'Worthing', slug: 'worthing', population: 113094 },
    { name: 'Chatham', slug: 'chatham', population: 81982 },
    { name: 'Rugby', slug: 'rugby', population: 78125 },
    { name: 'Dunfermline', slug: 'dunfermline', population: 58508 },
    { name: 'Paisley', slug: 'paisley', population: 77270 }
  ]
};
